import apiForluz from './api';

export class ComunicacaoPlanoService {
  getDocumentosComunicacaoPlano = async (plano, Ano, Mes) => {
    const params =
      Mes === ''
        ? {
            plano,
            Ano,
          }
        : {
            plano,
            Ano,
            Mes,
          };
    const response = await apiForluz.get('ObterComunicacaoPlanos', {
      params,
    });
    return response.data.results;
  };
}
